module.exports = __webpack_public_path__ + "static/main-screen-216d2d8ed8a5b6f7cb05f8be1b18e69e.png";